import dayjs from "dayjs";

export const minDate = dayjs("2007-01-01");
